import axios from 'axios'
import { CustomNotificationActionTypeEnumResponse } from '@/modules/configurationModule/detail/automation/notifications/automation-notifications-case/services/configuration-case-automatic-notification-action-type/configuration-case-automatic-notification-action-type.dto'

class ConfigurationCaseAutomaticNotificationActionTypeService {
    async getCustomNotificationActionTypes(): Promise<CustomNotificationActionTypeEnumResponse[]> {
        const response =
            await axios.get<CustomNotificationActionTypeEnumResponse[]>(
                `/configuration/caseAutomaticNotificationActionTypes`)
        return response.data
    }
}
export const configurationCaseAutomaticNotificationActionTypeService = new ConfigurationCaseAutomaticNotificationActionTypeService()
